import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Crown } from 'lucide-react';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
};

const SubscriptionCard = ({ profile }) => {
  const navigate = useNavigate();

  return (
    <Card className="card-surface border-[#27272A]" data-testid="usage-stats-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
          <Crown className="w-5 h-5 text-[#D4AF37]" />
          Subscription Status
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {profile.is_premium ? (
          <div>
            <div className="px-4 py-3 rounded-lg bg-[#D4AF37] bg-opacity-20 border border-[#D4AF37]">
              <p className="text-[#D4AF37] font-semibold">Premium Active</p>
              <p className="text-sm text-[#A1A1AA] mt-1">Valid until {formatDate(profile.premium_until)}</p>
            </div>
            <p className="text-sm text-[#A1A1AA] mt-4">Enjoying unlimited topics and priority support</p>
          </div>
        ) : (
          <div>
            <div className="px-4 py-3 rounded-lg bg-[#27272A]">
              <p className="text-[#F9FAFB] font-semibold">Free Tier</p>
              <p className="text-sm text-[#A1A1AA] mt-1">Topics today: {profile.topics_today}/1</p>
            </div>
            <Button onClick={() => navigate('/support')} className="btn-gold rounded-full mt-4" data-testid="upgrade-premium-button">
              Upgrade to Premium - $1 for 24 hours
            </Button>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default SubscriptionCard;
